import React from 'react'
import "../styles/Home.css"
const Home = () => {
  return (
      <div className="home">
          <div className="about">
              <h2>Hi,my name is Tamara</h2>
              <br></br><br></br>
              <div className="prompt">
                  <p>A software developer with a passion for learning and create</p>
              </div>
          </div>  
          <div className="skills">
              <h1>Skills</h1>
              <ol clasName="list">
                  <li className='item'>
                      <h2>Front End</h2>
                      <span>HTML,CSS,React.js,jQuery,Bootstrap,TailwindCSS,StyledComponents,
                          NPM,YARN,MaterialUI
                      </span>
                  </li>
                  <li className='item'>
                      <h2>UI/UX</h2>
                      <span>Adobe XD,Figma,inDesign,Illustrator</span>
                      
                  </li>
                  <li className='item'>
                      <h2>Languages</h2>
                      <span>JavaScript,Java,C,C++,Python
                      </span>
                  </li>
              </ol>
          </div>    
      
      </div>
  )
}

export default Home;